<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="partner-lists-page custom-vs-tabs slot-border-top">
        <!-- <vs-tab label="Registrars - CNIC">
          <div class="tab-text">
            <CNICRegistrarList></CNICRegistrarList>
          </div>
        </vs-tab> -->

        <vs-tab label="Registrars">
          <div class="tab-text">
            <TucowsRegistrarList></TucowsRegistrarList>
          </div>
        </vs-tab>

        <vs-tab label="Resellers">
          <div class="tab-text">
            <ResellerList></ResellerList>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <ViewOrEditCNICRegistrar></ViewOrEditCNICRegistrar>
    <ViewOrEditTucowsRegistrar></ViewOrEditTucowsRegistrar>

    <ViewOrEditReseller></ViewOrEditReseller>
  </div>
</template>

<script>
import CNICRegistrarList from '@/components/ag-grid-tables/partners/CNICRegistrarList.vue';
import TucowsRegistrarList from '@/components/ag-grid-tables/partners/TucowsRegistrarList.vue';
import ResellerList from '@/components/ag-grid-tables/partners/ResellerList.vue';

import ViewOrEditCNICRegistrar from '@/components/ag-grid-tables/partners/ViewOrEditCNICRegistrar.vue';
import ViewOrEditTucowsRegistrar from '@/components/ag-grid-tables/partners/ViewOrEditTucowsRegistrar.vue';
import ViewOrEditReseller from '@/components/ag-grid-tables/partners/ViewOrEditReseller.vue';

export default {
  name: 'PartnerList',
  components: {
    CNICRegistrarList,
    TucowsRegistrarList,
    ResellerList,
    ViewOrEditCNICRegistrar,
    ViewOrEditTucowsRegistrar,
    ViewOrEditReseller
  }
}
</script>

<style>

</style>